module.exports = __webpack_public_path__ + "media/images/ir/common/bg_pagetitle-962e697275df7bceaf2bb88c1c88899b.svg";